import { Button } from '@/components/Button/Button'
import { Loader } from '@/components/Loader/Loader'
import { Message } from '@/components/Message/Message'
import { RepoItem } from '@/components/RepoList/RepoItem/RepoItem'
import { useGeneratorState } from '@/state/generator'
import { useRepoListState } from '@/state/repoList'
import { useUserState } from '@/state/user'
import { changeRepos } from '@/utils/repos'
import type { FunctionalComponent } from 'preact'
import { useEffect } from 'preact/hooks'
import { useShallow } from 'zustand/shallow'
import styles from './index.module.scss'

export const RepoList: FunctionalComponent = () => {
  const user = useUserState(s => s.user)
  const repoIds = useRepoListState(useShallow(s => s.list.map(item => item.id)))
  const resetCommits = useGeneratorState(s => s.reset)

  const loading = useRepoListState(s => s.loading)
  const empty = useRepoListState(s => s.empty)

  useEffect(() => {
    return () => {
      resetCommits()
    }
  }, [])

  return (
    <div class={styles.root}>
      {repoIds.length === 0 && loading
        ? (
          <Message>
            Loading <Loader />
          </Message>
        )
        : repoIds.length === 0 && empty
        ? (
          <Message>
            <div>
              No repositories connected.
            </div>
            <div>
              Connect your GitHub repos to start generating posts from commits.
            </div>
            <div>
              <Button
                type='primary'
                onClick={() => {
                  if (!user) return
                  changeRepos(user.githubId)
                }}
              >
                connect repos
              </Button>
            </div>
          </Message>
        )
        : (
          repoIds.map(repoId => (
            <RepoItem
              repoId={repoId}
            />
          ))
        )}
    </div>
  )
}
